import { defineMessages } from 'react-intl';

export default defineMessages({
  store: {
    id: 'locationtype.store.title',
    defaultMessage: 'Store'
  },
  deposit: {
    id: 'locationtype.deposit.title',
    defaultMessage: 'Deposit'
  },
  disposal: {
    id: 'locationtype.disposal.title',
    defaultMessage: 'Disposal'
  },
  hold: {
    id: 'locationtype.hold.title',
    defaultMessage: 'Hold'
  },
  layby: {
    id: 'locationtype.layby.title',
    defaultMessage: 'LayBy'
  },
  pickup: {
    id: 'locationtype.pickup.title',
    defaultMessage: 'Pick-Up'
  },
  qa: {
    id: 'locationtype.qa.title',
    defaultMessage: 'QA'
  },
  reserved: {
    id: 'locationtype.reserved.title',
    defaultMessage: 'Reserved'
  },
  return: {
    id: 'locationtype.return.title',
    defaultMessage: 'Return'
  },
  shipping: {
    id: 'locationtype.shipping.title',
    defaultMessage: 'Shipping'
  },
  preorder: {
    id: 'locationtype.preorder.title',
    defaultMessage: 'Pre-order'
  }
  
});
